import React, { useCallback, useRef } from 'react';

import {
  ButtonSize,
  ButtonIcon,
  OutlinedButton,
} from '@prisjakt/ui/button/variants';
import { Floater, Alignment } from '@prisjakt/ui/floater';
import { NudgeUp } from '@prisjakt/ui/hideable/variants';

import * as S from './styles';
import { IconChevronDown, IconChevronUp } from '@prisjakt/ui/icon';
import { zindex } from 'src/ui/zindex';

type Props = {
  children: React.ReactNode;
  count?: number;
  dataTestType?: string;
  dataTestProperty?: string;
  disabled?: boolean;
  id: string;
  isOpen: boolean;
  onFilterToggle: (id: string) => void;
  title: string;
};

export const FilterFloater = (props: Props) => {
  const {
    children,
    count,
    dataTestType,
    dataTestProperty,
    disabled = false,
    id,
    isOpen,
    onFilterToggle,
    title,
  } = props;

  const filterRef = useRef<HTMLDivElement>(null);

  const onClickHandler = useCallback(
    () => typeof onFilterToggle === 'function' && onFilterToggle(id),
    [onFilterToggle, id]
  );

  return (
    <S.FilterWrapper
      ref={filterRef}
      data-test="FeaturedFilter"
      data-test-type={dataTestType}
      data-test-property={dataTestProperty}
    >
      <OutlinedButton
        containerProps={{ 'data-test': 'FeaturedFilterButton' }}
        disabled={Boolean(disabled)}
        onClick={onClickHandler}
        selected={Boolean(isOpen)}
        size={ButtonSize.SMALL}
      >
        <S.FilterButtonText>
          {count && count > 0 ? `${title} (${count})` : title}
        </S.FilterButtonText>
        <ButtonIcon>
          {isOpen ? <IconChevronUp /> : <IconChevronDown />}
        </ButtonIcon>
      </OutlinedButton>

      <Floater
        horizontalAlign={Alignment.Start}
        verticalAlign={Alignment.EndOutside}
        zIndex={zindex.modal}
      >
        <NudgeUp visible={isOpen}>
          <S.FilterPopup>
            <S.FilterContent>
              <S.Content>{children}</S.Content>
            </S.FilterContent>
          </S.FilterPopup>
        </NudgeUp>
      </Floater>
    </S.FilterWrapper>
  );
};
